import { Trans } from "../utils/i18n";
import React from "react";

export const queueDetailConfigAmazonLocker = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "groups": [
        {
            "heading": <Trans i18nKey="queueDetail.timestamps.title">On-Site Date & Time</Trans>,
            "fields": [
                {
                    "name": "start_datetime",
                    "label": <Trans i18nKey="queueDetail.start_datetime.label">On-Site Start Date & Time</Trans>,
                    "size": "half",
                    "type": "datetimepicker",
                    "allowPast": true,
                    "required": false,
                },
                {
                    "name": "end_datetime",
                    "label": <Trans i18nKey="queueDetail.end_datetime.label">On-Site Completion Date & Time</Trans>,
                    "size": "half",
                    "type": "datetimepicker",
                    "allowPast": true,
                    "required": false,
                },
            ],
            "conditionFunction": (values, pageProps) => pageProps?.statuses?.find(item => String(item.id) === String(values.status_id))?.key !== 'closed',
        },
        {
            "heading": <Trans i18nKey="queueDetail.timestamps.title">On-Site Date & Time</Trans>,
            "fields": [
                {
                    "name": "start_datetime",
                    "label": <Trans i18nKey="queueDetail.start_datetime.label">On-Site Start Date & Time</Trans>,
                    "size": "half",
                    "type": "datetimepicker",
                    "allowPast": true,
                    "required": true,
                },
                {
                    "name": "end_datetime",
                    "label": <Trans i18nKey="queueDetail.end_datetime.label">On-Site Completion Date & Time</Trans>,
                    "size": "half",
                    "type": "datetimepicker",
                    "allowPast": true,
                    "required": true,
                },
            ],
            "conditionFunction": (values, pageProps) => pageProps?.statuses?.find(item => String(item.id) === String(values.status_id))?.key === 'closed',
        },
    ],
}
